import { __module as e } from "../../../_virtual/equals.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function (e, t) {
  return (0, a.default)(e), e === t;
}, a = t && t.__esModule ? t : {
  default: t
}, e.exports = r.default, e.exports.default = r.default;
var r,
  a,
  s = e.exports;
export { s as e };